/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PreferredCheckbox/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'
import TysiaCheckboxText from 'DesignSystem/TysiaCheckbox/TysiaCheckboxText/index'



/** @type {import('Simple/types.js').View} */
export default function PreferredCheckbox({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Images/Content/Content/Content/Content/CreateIteroScanRequest/Content/Content/Step/Account/Content/Accounts/PreferredCheckbox",
  onChange
  
}) {
let selectedSetPreferredValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'set_preferred',
})
let selectedSetPreferredChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
path: 'set_preferred',
})
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="selected.set_preferred"
 value={selectedSetPreferredValueData}
 onChange={selectedSetPreferredChangeData}
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
/>
<TysiaCheckboxText
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxText`}
 text="Set this account as preferred"
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}